import { render, staticRenderFns } from "./ComponentSettingsForm.vue?vue&type=template&id=0c5f666b&scoped=true"
import script from "./ComponentSettingsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentSettingsForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComponentSettingsForm.vue?vue&type=style&index=0&id=0c5f666b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5f666b",
  null
  
)

export default component.exports